import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, Fingerprint, Camera } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const BiometricStatsCards = ({ filteredUnmappedData }) => {
  const { t } = useTranslation();
  return (
  <div className="grid gap-4 md:grid-cols-3">
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <AlertTriangle className="h-4 w-4 text-yellow-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('biometricComp.unmapped')}</p>
            <p className="text-2xl font-bold text-yellow-600">{filteredUnmappedData.length}</p>
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Fingerprint className="h-4 w-4 text-blue-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('biometricComp.totalBio')}</p>
            <p className="text-2xl font-bold text-blue-600">
              {filteredUnmappedData.reduce((sum, item) => sum + item.biometric_count, 0)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardContent className="p-6">
        <div className="flex items-center space-x-2">
          <Camera className="h-4 w-4 text-green-600" />
          <div>
            <p className="text-xs font-medium text-muted-foreground">{t('biometricComp.totalPhotos')}</p>
            <p className="text-2xl font-bold text-green-600">
              {filteredUnmappedData.reduce((sum, item) => sum + item.photo_count, 0)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default BiometricStatsCards;
